import s from "../style";
import { motion } from "framer-motion";
import abhyaz from "../assets/abhyaz.png";
import sv from "../assets/sv.png";
import siemens from "../assets/siemens.jpeg";

export const Experience = () => {
  return (
    <div className={` ${s.flexCenter} flex-col text-xs md:text-sm`}>
      <div
        className="head my-8 text-white text-xl md:text-4xl lg:text-6xl font-bold "
        data-aos="fade-right"
        data-aos-duration="500"
      >
        Experiences
      </div>
      <div className={`${s.flexCenter} flex-wrap text-xs md:text-base`}>
        {/* Siemens */}
        <motion.div
          data-aos="flip-right"
          data-aos-duration="1500"
          whileHover={{
            color: "#ff1493",
            scale: 1.1,
          }}
          transition={{ duration: 0.1 }}
          className={`${s.flexBetween} flex-col text-cold-pink m-3 md:m-8 rounded-2xl w-[250px] md:w-[350px] h-[350px] md:h-[470px] border-2 border-hot-pink p-5`}
        >
          <div className={`${s.flexCenter}`}>
            <img
              src={siemens}
              alt="Siemens"
              className="w-10 md:w-20 h-10 md:h-20 object-contain mx-1 rounded-xl"
            />
            <div className="text-lg md:text-2xl font-semibold my-2">
              Software Developer
            </div>
          </div>
          <div className="my-2">
            • Enhanced <strong className="text-hot-pink">CKAN 2.10.4</strong> by creating
            custom extensions, <strong className="text-hot-pink">multi-resource upload</strong>,
            <strong className="text-hot-pink"> dynamic tag modals</strong> & API integrations.
          </div>
          <div className="my-2">
            • Developed reusable <strong className="text-hot-pink">micro frontend</strong> components
            (<strong className="text-hot-pink">charts</strong>, <strong className="text-hot-pink">maps</strong>, cards)
            in <strong className="text-hot-pink">Angular 19</strong> & <strong className="text-hot-pink">React</strong>,
            packaged via private registry with <strong className="text-hot-pink">Keycloak</strong> authentication.
          </div>
          <div className="my-2">
            • Built <strong className="text-hot-pink">Angular 17</strong> UI components library on top of
            <strong className="text-hot-pink"> Bootstrap</strong> loaders, menus, form modules for
            scalable internal products.
          </div>
        </motion.div>


        {/* Skillvalley */}
        <motion.div
          data-aos="flip-right"
          data-aos-duration="1500"
          whileHover={{ color: "#ff1493", scale: 1.1 }}
          transition={{ duration: 0.1 }}
          className={`${s.flexBetween} flex-col text-cold-pink m-3 md:m-8 rounded-2xl w-[250px] md:w-[350px] h-[350px] md:h-[470px] border-2 border-hot-pink p-5`}
        >
          <div className={`${s.flexCenter}`}>
            <img src={sv} alt="sv" className="w-10 md:w-20 h-10 md:h-20 object-cover mx-1" />
            <div className="text-2xl md:text-4xl font-semibold my-2">
              Skillvalley
            </div>
          </div>
          <div className="text-lg md:text-2xl font-semibold my-2">
            Product Developer
          </div>
          <div className=" my-2">

            • Conducted interviews with several
            <strong className="text-hot-pink"> content writers</strong> and
            writing space CEOs identifying pain points of the problem.
          </div>
          <div className=" my-2">

            • <strong className="text-hot-pink">Led</strong> the Frontend
            department directing all the end-to-end processes to ensure a user
            friendly UI using <strong className="text-hot-pink">Figma </strong>
            and <strong className="text-hot-pink">Tailwind CSS</strong>.
          </div>
          <div className=" my-2">

            • Deliverables: Incorporated
            <strong className="text-hot-pink"> Quill API</strong> to make the
            text editor, developed the APIs for the
            <strong className="text-hot-pink">Real-time collaboration</strong>
            feature.
          </div>
        </motion.div>

        <motion.div
          data-aos="flip-right"
          data-aos-duration="1500"
          whileHover={{ color: "#ff1493", scale: 1.1 }}
          transition={{ duration: 0.1 }}
          className={`${s.flexBetween} flex-col text-cold-pink m-3 md:m-8 rounded-2xl w-[250px] md:w-[350px] h-[350px] md:h-[470px] border-2 border-hot-pink p-5`}
        >

          <div className={`${s.flexCenter} flex-col`}>

            <img
              src={abhyaz}
              alt="abhyaz"
              className="w-20 md:w-40 mx-1 md:mx-3 h-10 md:h-16"
            />
            <div className="text-lg md:text-2xl font-semibold my-4 md:my-6">
              Project Intern
            </div>
          </div>
          <div className=" mt-6">

            • Deliverables: Optimized and improved the
            <strong className="text-hot-pink">SEO of 3 pages</strong> of Abhyaz
            by an impressive <strong className="text-hot-pink">40%</strong>.
          </div>
          <div className=" my-2">
            • Products Led: Conceptualized and created a new site
            <a href="https://cnctrain.com/" className="text-hot-pink">
              CNC Train
            </a>
            using <strong className="text-hot-pink">ZOHO editor </strong>with
            another intern in 2 weeks.
          </div>
          <div className=" my-2">

            • Strategized marketing campaigns and posters for Abhyaz during its
            expansion.
          </div>
        </motion.div>
      </div>
    </div>
  );
};
